import { useState, useEffect, useContext } from 'react'
import AuthContext from "../../contexte/AuthContext";
import { useTranslation } from 'react-i18next';
import './home.css'
import i18n from "translation/i18next";

// import all components
import DashboardLayout from "components/layout/dashboard/DashboardLayout";
import MainActions from 'components/DataComponents/MainActions/MainActions';
import KPI from 'components/DataComponents/KPI/KPI';
import NewUsersGraph from 'components/DataComponents/newUsersGraph/NewUsersGraph';
import { SkeletonActions, SkeletonBroker, SkeletonKPI, SkeletonTable } from 'components/skeleton/Skeleton';

// import all services
import { fetchMainAction } from 'services/fetchMainAction';
import { fetchTradeGraph } from 'services/fetchTradeGraph';
import BrokerAlert from 'components/DataComponents/BrokerAlert/BrokerAlert';
import { fetchExanteAvailable, fetchLmaxAvailable } from 'services/fetchAccounts';

const Home = () => {

    const { user, verifyUser } = useContext(AuthContext)
    const { t } = useTranslation();
    const today = new Date()
    const role = verifyUser()?.role;
    const [loading, setLoading] = useState(true)

    console.log({ role });

    // Declare all data States
    const [mainActionsData, setMainActionsData] = useState([])
    const [graphData, setGraphData] = useState([])
    const [exanteAvailable, setExanteAvailable] = useState({ tradesAvailable: 0, marginAvailable: 0 })
    const [lmaxAvailable, setLmaxAvailable] = useState({ shortAvailable: 0, marginAvailable: 0 })

    // StockMostTrade states
    const [periode, setPeriode] = useState("month")


    const loadMainActions = async () => {
        try {
            const mainActionsRequest = await fetchMainAction(user)
            console.log('mainActionsRequest', mainActionsRequest)
            setMainActionsData(mainActionsRequest)
        } catch (error) {
            setMainActionsData([-1, -1, -1, -1, -1])

        }

    }

    const loadTradeGraph = async () => {
        try {
            const tradeGraphRequest = await fetchTradeGraph(user, periode, today)
            console.log('tradeGraphRequest', tradeGraphRequest)
            setGraphData(tradeGraphRequest)
        } catch (error) {
            setGraphData([])
        }
    }

    const loadExanteAvailable = async () => {
        try {
            const available = await fetchExanteAvailable(user);
            console.log('exante available', available)
            setExanteAvailable(available)
        } catch (error) {
            setExanteAvailable({ tradesAvailable: null, marginAvailable: null })
        }
    }

    const loadLmaxAvailable = async () => {
        try {
            const available = await fetchLmaxAvailable(user);
            console.log('lmax available', available)
            setLmaxAvailable(available)
        } catch (error) {
            setLmaxAvailable({ shortAvailable: null, marginAvailable: null })
        }
    }


    const loadData = async () => {
        try {
            if ([1, 2].includes(role))
                await Promise.all([loadMainActions(), loadTradeGraph(), loadExanteAvailable(), loadLmaxAvailable()]);
        } catch (error) {
            console.error('Error getting data');
            throw error
        } finally {
            setLoading(false)

        }

    }

    const getDashboard = (role) => {
        if ([1, 2].includes(role)) 
            return                     <div className='home_layout_left'>
                        <MainActions mainActionsData={mainActionsData} />
                        <hr />
                        <BrokerAlert exante={exanteAvailable} lmax={lmaxAvailable} isAdmin={role === 1} />
                        <KPI />
                        <NewUsersGraph graphData={graphData} />
                    </div>
            return <div className='home_layout_left'></div>
    }

    useEffect(() => {
        loadData()
    }, [])

    return (
        <DashboardLayout page={t('pages_name.accueil')}>
            <div className='home_layout'>
                {!loading ? (
                    getDashboard(role)
                ) : (
                    <div className='home_layout_left'>
                        <SkeletonActions count={6} />
                        <hr />
                        <SkeletonBroker />
                        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', padding: '20px 24px' }}>
                            <div className="skeleton skeleton_text" style={{ width: '120px', height: '16px', marginBottom: '16px' }} />
                            <SkeletonKPI count={6} />
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>


    )
}

export default Home